import styled from '@emotion/styled'

import { Skeleton } from 'lmcv/components/Skeleton'

import { ListElement, TextTitle, ItemPoints, ContentElement, CircleElement, Infos, TextDate, TextPoints } from './styles'

export function ListSkeleton () {
  return (
    <ListElement>
      {Array(6)
        .fill()
        .map((item, index) => (
          <ItemPoints key={`${item}-${index}`}>
            <ContentElement>
              <CircleElement>
                <Skeleton width="100%" height="100%" rounded />
              </CircleElement>

              <Infos>
                <TextDate>
                  <Skeleton width="60px" height="13px" />
                </TextDate>
                <TextTitle>
                  <Skeleton width="100px" height="16px" />
                </TextTitle>
              </Infos>
            </ContentElement>

            <TextPoints>
              <Skeleton width="40px" height="20px" />
            </TextPoints>
          </ItemPoints>
        ))}
    </ListElement>
  )
}
